import * as React from 'react';

import { cn } from '@/lib/utils';
import { Label } from './label';

interface TextareaProps extends React.ComponentProps<'textarea'> {}

function Textarea({ className, ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      {...props}
    />
  );
}

interface TextareaWithLabelProps extends TextareaProps {
  label: string;
  error?: boolean;
  helperText?: string;
}

function TextareaWithLabel({ label, error, id, helperText, ...props }: TextareaWithLabelProps) {
  return (
    <div className="grid w-full gap-3">
      <Label htmlFor={id}>{label}</Label>
      <div className="flex flex-col gap-1">
        <Textarea {...props} />
        {error && <p className="text-red-500 text-xs">{helperText}</p>}
      </div>
    </div>
  );
}

export { Textarea, TextareaWithLabel };
